import { StoreEntity } from '@/services/types/store.type';
import { create } from 'zustand';

/** 상담 신청 맥락(요금제 카드에서 연 경우). 예약 요청에 함께 싣는다. */
export interface ReserveContext {
  pricingPlanId?: number;
  pricingPlanPriceId?: number;
  entrySource?: string;
  /** 폼에 보여 줄 요금제 표시명(저장되는 이름은 서버가 id로 다시 만든다) */
  pricingLabel?: string;
  /** 문의유형 미리 선택(선택한 면허 탭) */
  consultType?: '1종' | '2종';
}

interface ModalStore {
  isOpen: boolean;
  selectedBranch: StoreEntity | null;
  reserveContext: ReserveContext | null;
  open: (branch?: StoreEntity, context?: ReserveContext) => void;
  close: () => void;
  isSidebarOpen: boolean;
  openSidebar: () => void;
  closeSidebar: () => void;
}

export const useModalStore = create<ModalStore>((set) => ({
  isOpen: false,
  selectedBranch: null,
  reserveContext: null,
  open: (branch, context) =>
    set({
      isOpen: true,
      selectedBranch: branch || null,
      reserveContext: context || null,
    }),
  close: () =>
    set({ isOpen: false, selectedBranch: null, reserveContext: null }),
  isSidebarOpen: false,
  openSidebar: () => set({ isSidebarOpen: true }),
  closeSidebar: () => set({ isSidebarOpen: false }),
}));
